import { NgModule } from '@angular/core';
import {
  FooterComponent,
  HeaderComponent,
  MenuComponent,
  NextPage,
} from '@cvx/nextpage';

@NgModule({
  imports: [NextPage],
  exports: [MenuComponent, HeaderComponent, FooterComponent],
})
export class MenuModule {}
